import * as Accordion from '@radix-ui/react-accordion';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { MobileLoader } from '../loader/index.tsx';

import s from './dataset-accordion.module.css';

const ChevronDown = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.625 9L12.625 15L18.625 9"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Chain = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.91675 8.66672C7.20305 9.04948 7.56832 9.36618 7.98778 9.59535C8.40724 9.82452 8.87109 9.9608 9.34785 9.99495C9.82461 10.0291 10.3031 9.9603 10.751 9.79325C11.1988 9.62619 11.6055 9.36477 11.9434 9.02672L13.9434 7.02672C14.5506 6.39805 14.8866 5.55604 14.879 4.68205C14.8714 3.80806 14.5208 2.97202 13.9028 2.354C13.2848 1.73597 12.4487 1.38541 11.5748 1.37781C10.7008 1.37022 9.85876 1.7062 9.23008 2.31339L8.08341 3.45339"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.58322 7.33332C9.29692 6.95057 8.93165 6.63387 8.51219 6.40469C8.09273 6.17552 7.62888 6.03924 7.15212 6.0051C6.67536 5.97095 6.19683 6.03974 5.74899 6.2068C5.30115 6.37386 4.89448 6.63527 4.55656 6.97332L2.55656 8.97332C1.94936 9.60199 1.61338 10.444 1.62098 11.318C1.62857 12.192 1.97913 13.028 2.59716 13.646C3.21519 14.2641 4.05123 14.6146 4.92522 14.6222C5.79921 14.6298 6.64121 14.2938 7.26989 13.6867L8.40989 12.5467"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DatasetAccordion = ({ datasets = [], show, loading }) => {
  const router = useRouter();

  return loading ? (
    <MobileLoader length={10} />
  ) : datasets?.error ? (
    <p className="lg:hidden text-white text-3xl">Internal Server Error</p>
  ) : datasets.length < 1 ? (
    <div className="text-neutral-300 text-center py-28 px-[75px] border border-tundora rounded-lg lg:hidden">
      There are no results for the filters&nbsp;provided
      <Link
        href={router.pathname}
        scroll={false}
        className="mt-4 text-white block max-w-max cursor-pointer mx-auto">
        Clear Filters
      </Link>
    </div>
  ) : (
    <Accordion.Root
      collapsible
      type="single"
      className="border border-tundora rounded-lg overflow-hidden lg:hidden mb-14"
    >
      {datasets?.slice(0, show).map(dataset => (
        <Accordion.Item
          key={dataset.id}
          value={dataset.id}
          className="border-b last:border-b-0 border-tundora"
        >
          <Accordion.Trigger className={s.trigger}>
            <Accordion.Header className="flex items-start justify-between space-x-2">
              <div className="flex items-center space-x-4">
                <div className="w-[45px] h-[45px] relative overflow-hidden rounded-full">
                  <Image
                    src={dataset.logoBack.url}
                    alt={dataset.logoBack.alt}
                    layout="fill"
                    objectFit="cover"
                  />
                  <Image
                    src={dataset.logoFront.url}
                    alt={dataset.logoFront.alt}
                    layout="fill"
                    objectFit="cover"
                  />
                </div>
                <div className="flex flex-col flex-1 items-start">
                  <p className="text-xs text-left leading-5 text-white">
                    {dataset.title} ({dataset.date.slice(0, 4)})
                  </p>
                  <p className="text-xs text-left leading-5 text-neutral-500">{`by ${dataset.provider}`}</p>
                  <p className="text-xs text-left leading-5 text-white">{dataset.location}</p>
                </div>
              </div>
              <ChevronDown />
            </Accordion.Header>
          </Accordion.Trigger>
          <Accordion.Content className={s.content}>
            <div className="text-xs leading-5 text-white border-y py-4 border-tundora">
              <p>Data Provided</p>
              {dataset.dataProvided}
            </div>
            <div className="text-xs leading-5 text-white border-b py-4 border-tundora">
              <p>Annotation</p>
              {dataset.annotation}
            </div>
            <div className="text-xs leading-5 text-white border-b py-4 border-tundora">
              <p>Diversity</p>
              {dataset.diversity}
            </div>
            <div className="text-xs leading-5 text-white py-4 border-tundora">
              <p>Traffic</p>
              {dataset.traffic}
            </div>
            {dataset.link && (
              (<Link
                href={dataset.link}
                className="p-2 border lg:hidden inline-block border-tundora rounded-full">

                <Chain />

              </Link>)
            )}
          </Accordion.Content>
        </Accordion.Item>
      ))}
    </Accordion.Root>
  );
};

export default DatasetAccordion;
